export default __webpack_public_path__ + "static/media/AGREABILITE.c61c427c.gif";